import { HobanLogo } from "./HobanLogo";
import { SafersLogo } from "./SafersLogo";

interface BrandLockupProps {
  className?: string;
}

/**
 * SAFERS · 구분선 · 호반건설 락업. app 과 admin 로그인이 같은 것을 쓴다.
 *
 * 폰(390px)에서 폭 절약 — 폰에서는 SAFERS 마크만 표시해서 락업 폭을 절약하고,
 * sm 이상에서는 워드마크 풀버전을 본다. 호반은 폰에서도 함께 보여 발주처 CI 표시.
 * 둘 다 한 단계 축소해서 호반 심볼이 SAFERS 마크보다 커지지 않도록 한다.
 *
 * 호반이 `reverse` 인 이유 — 워드마크가 `currentColor` 를 따라야 어두운 페인에서
 * 희게, 밝은 폼에서 진하게 나온다. 규격색(진회색)이면 어두운 면에서 묻힌다.
 */
export function BrandLockup({ className = "" }: BrandLockupProps) {
  return (
    <span className={`flex items-center gap-2 sm:gap-3 ${className}`}>
      <SafersLogo className="h-[1.125rem] sm:h-[1.625rem]" />
      <span aria-hidden="true" className="h-3 w-px bg-current opacity-20 sm:h-4" />
      <HobanLogo variant="reverse" className="h-[1rem] sm:h-[1.375rem]" />
    </span>
  );
}
